import type { IUpdateUserRequest } from '../types/UpdateUser';
import type { IUpdateUserApiPayload } from '../types/UpdateUser.api';

const toApiPayload = (input: IUpdateUserRequest): IUpdateUserApiPayload => ({
  first_name: input.firstName,
  last_name: input.lastName,
});

export const UpdateUserAdapters = {
  toApiPayload,
};
